/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiBaseService } from '../dapi-base-service';
import { DapiHttpResponse } from '../dapi-http-response';
import { DapiRequestBuilder } from '../dapi-request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { FinnairEmergencyContactUpdateRequest } from '../models/finnair-emergency-contact-update-request';


/**
 * Emergency contact in order
 */
@Injectable({
  providedIn: 'root',
})
export class EmergencyContactService extends DapiBaseService {
  constructor(
    http: HttpClient
  ) {
    super(http);
  }

  /**
   * Path part for operation updateEmergencyContactDetails
   */
  static readonly UpdateEmergencyContactDetailsPath = '/api/v2/order/{orderId}/emergency-contact';

  /**
   * updateEmergencyContactDetails.
   *
   * Adds/Updates emergency contact details to the order
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateEmergencyContactDetails()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEmergencyContactDetails$Response(rootUrl: string, params: {
    orderId: string;
    hash?: string;
    locale?: string;
    body: FinnairEmergencyContactUpdateRequest
  }): Observable<DapiHttpResponse<void>> {
    const rb = new DapiRequestBuilder(rootUrl, EmergencyContactService.UpdateEmergencyContactDetailsPath, 'patch');

    if (params) {
      rb.path('orderId', params.orderId, {});
      rb.query('hash', params.hash, {});
      rb.query('locale', params.locale, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as DapiHttpResponse<void>;
      }),
      catchErrorAsJson()
    );
  }

  /**
   * updateEmergencyContactDetails.
   *
   * Adds/Updates emergency contact details to the order
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateEmergencyContactDetails$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEmergencyContactDetails(rootUrl: string, params: {
    orderId: string;
    hash?: string;
    locale?: string;
    body: FinnairEmergencyContactUpdateRequest
  }): Observable<void> {
    return this.updateEmergencyContactDetails$Response(rootUrl, params).pipe(
      map((r: DapiHttpResponse<void>) => r.body as void)
    );
  }

}
